import { type Chat } from '@pubnub/chat';
import { useEffect } from 'react';
import { useConversationsStore } from '@avanta/shared/stores/chat/conversations';

interface UseTypingSubscriptionParams {
  activeChannelId: string | null;
  chat: Chat | null;
  otherUserId: string | undefined;
}

export const useTypingSubscription = ({
  activeChannelId,
  chat,
  otherUserId,
}: UseTypingSubscriptionParams): void => {
  const setTyping = useConversationsStore(state => state.setIsTyping);

  useEffect(() => {
    if (!activeChannelId || !chat) return;
    let cancelled = false;
    let unsub: (() => void) | undefined;

    const setup = async (): Promise<void> => {
      const channel = await chat.getChannel(activeChannelId);
      if (!channel || cancelled) return;
      unsub = channel.getTyping((typingUserIds: string[]) => {
        if (cancelled) return;
        setTyping(!!otherUserId && typingUserIds.includes(otherUserId));
      });
    };

    setup();

    return (): void => {
      cancelled = true;
      unsub?.();
      setTyping(false);
    };
  }, [activeChannelId, chat, otherUserId, setTyping]);
};
